import Device from "baseStyles/enums/device";
import { SuiStylesType, useSuiStyles } from "baseStyles/useSuiStyles";
import { FlexBoxPropsType } from "schoolUiComponents/basic/Box/FlexBox/types";
import { InputPropsType } from "schoolUiComponents/basic/Input/types";

type PropsType = {}

type StylesType = {
}

const Styles: SuiStylesType<PropsType, StylesType> = {
    [Device.types.Desktop]: ({theme}) => {
        return {}
    }
}

const LoginStyles = useSuiStyles(Styles);

export default LoginStyles;